import React from 'react';
import PropTypes from 'prop-types';

// @atlaskit
import BitbucketSourceIcon from '@atlaskit/icon/glyph/bitbucket/source';

// @source
import * as Styled from '../../styled';

const TableRow = ({ text, action }) => (
  <Styled.TableRow>
    <Styled.TableRowIcon>
      <BitbucketSourceIcon size="small" />
    </Styled.TableRowIcon>
    <Styled.TableRowText>{text}</Styled.TableRowText>
    <Styled.TableRowIcon>{action}</Styled.TableRowIcon>
  </Styled.TableRow>
);

TableRow.propTypes = {
  text: PropTypes.string.isRequired,
  action: PropTypes.node.isRequired,
};

export default TableRow;
